import { getAccessToken } from './authSession.js';

const CODELY_EXPORT_ROLES = new Set(['ADMIN', 'CONTENT_MANAGER']);

function normalizeRole(value) {
  return String(value || '').trim().toUpperCase();
}

function readJwtPayload(token) {
  const [, payload] = String(token || '').split('.');
  if (!payload) return {};
  try {
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
    return JSON.parse(window.atob(padded));
  } catch {
    return {};
  }
}

function pushRole(values, role) {
  const normalized = normalizeRole(role);
  if (normalized) values.add(normalized);
}

function pushRoles(values, roles) {
  if (Array.isArray(roles)) {
    roles.forEach((role) => pushRole(values, role));
    return;
  }
  if (typeof roles === 'string') {
    roles.split(',').forEach((role) => pushRole(values, role));
  }
}

export function currentUserRoles(profile = null) {
  const roles = new Set();
  const payload = readJwtPayload(getAccessToken());

  pushRoles(roles, payload.USER_ROLES);
  pushRoles(roles, payload.roles);
  pushRoles(roles, payload.authorities);
  pushRole(roles, payload.USER_TYPE);
  pushRole(roles, payload.userType);

  if (profile) {
    const raw = profile.raw || profile;
    pushRoles(roles, raw.roles);
    pushRoles(roles, raw.authorities);
    pushRole(roles, raw.userType);
  }

  return roles;
}

export function canExportCodelyActivity(profile = null) {
  const roles = currentUserRoles(profile);
  return [...CODELY_EXPORT_ROLES].some((role) => roles.has(role));
}
